import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';
import { BrandCode, AgeCategory } from '../models/curriculum';

export type AgeCategoryAccess = {
  id: string;
  access: 'Active' | 'Expired' | 'Upcoming' | 'NoAccess';
  startDate?: string;
  endDate?: string;
};

export type CurriculumAccessMap = Record<AgeCategory, AgeCategoryAccess>;

export type CurriculumAccess = Record<BrandCode, CurriculumAccessMap>;
type GetCurriculumAccessResponse = CurriculumAccess;

export const getCurriculumAccess: () => Promise<CurriculumAccess> = () => {
  return cacheableRequest('/v1/org/curriculum/access').then(
    (response: AxiosResponse<GetCurriculumAccessResponse>) => response.data
  );
};
